import { render, staticRenderFns } from "./DataPanel.vue?vue&type=template&id=be41650a&scoped=true&"
import script from "./DataPanel.vue?vue&type=script&lang=js&"
export * from "./DataPanel.vue?vue&type=script&lang=js&"
import style0 from "./DataPanel.vue?vue&type=style&index=0&id=be41650a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be41650a",
  null
  
)

export default component.exports